import React from 'react';
export function WagesHeading() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", null, "Employee"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Sum of R&D Working Hours"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Relevant Anual Working Hours"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Share of R&D Working Hours"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Gross Wages A1: Excluding special payments"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Gross Wages A2: Sum of All Special Payments"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Sum of Gross Wages = A1 + A2"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Employer's social security contributions (\u2116 3 of 62 EStG)"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Gross Wage"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Employers' social security contributions"));
}